import { useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export interface ICaptcha {
  onVerify: (key: string) => void;
}

const Captcha = ({ onVerify }: ICaptcha) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    if (!executeRecaptcha) {
      return;
    }

    const handleReCaptchaVerify = async () => {
      onVerify(await executeRecaptcha('contact'));
    };

    handleReCaptchaVerify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [executeRecaptcha]);

  return <></>;
};

export default Captcha;
